import { Link } from "@merge-api/merge-javascript-shared";
import { NextPagePayloadInfo } from "../../config/types";
import useAgentHandlerLinkModalContext from "../context/useAgentHandlerLinkModalContext";
import CardHeader from "../shared/CardHeader";
import MergeLinkCardBase from "../shared/MergeLinkCardBase";
import NextStepButton from "../shared/NextStepButton";
import { TOS_FOOTER_URL } from "./TOSFooter";
import ConnectorSetupStepFormHeader from "./connector-setup/ConnectorSetupStepFormHeader";

export type Props = {
  linkingFlowPayload: NextPagePayloadInfo;
};

const TermsOfServicePage = ({ linkingFlowPayload }: Props) => {
  // hooks
  const { translate, onExit, getNextPageAndSetPage } = useAgentHandlerLinkModalContext();

  // derived state
  const connector = linkingFlowPayload.connector!;

  const onNext = () => {
    getNextPageAndSetPage({
      selected_connector: connector,
    });
  };

  return (
    <MergeLinkCardBase>
      <CardHeader onExit={onExit} />
      <ConnectorSetupStepFormHeader
        connector={connector}
        header={translate("terms-of-service-header", "Connect your account")}
        subHeader={
          <>
            {translate(
              "terms-of-service-body-1",
              "This integration is powered by Merge. Find out more",
            )}{" "}
            <Link href={TOS_FOOTER_URL}>{translate("terms-of-service-body-2", "here")}.</Link>
          </>
        }
      />
      <div className="w-full mb-5 px-5 flex flex-col flex-grow justify-end">
        <NextStepButton onClick={onNext}>{translate("next-button", "Next")}</NextStepButton>
      </div>
    </MergeLinkCardBase>
  );
};

export default TermsOfServicePage;
